import classNames from 'classnames';

import {EDITOR_MODE} from '@/Constant';
import CommentIcon from '@/assets/svg/ai/commentNormal2.svg?tsx';
import {AIChatPanelExpandSource, aiChatPanelExpandSourceObj} from '@/utils/document/aigc';
import {SideTabKey} from '@/interface';
import {feLogger, openRightComment} from '@/buried/index';

import styles from './style.module.scss';
import {openPanel} from '../utils/panelStatus';

interface IProps {
    show: boolean;
    documentMode?: EDITOR_MODE;
}

const Entry: React.FC<IProps> = ({
    show,
    documentMode,
}) => {
    const isPreview = documentMode === EDITOR_MODE.preview;


    function handleOpen(value: SideTabKey) {
        // 点击评论icon，打开右侧评论框，上报埋点
        feLogger(openRightComment());

        aiChatPanelExpandSourceObj.value = AIChatPanelExpandSource.entryIcon;
        openPanel({
            tab: value,
            isExternalNotComment: value !== SideTabKey.Comment,
        });
    }

    return (
        <div className={classNames(styles.entry, !show && styles.hidden, isPreview && styles.preview)}>
            <div
                className={styles.commentWrapper}
                data-tooltip-id="entryTooltip"
                data-tooltip-content="评论"
            >
                <CommentIcon
                    onClick={() => handleOpen(SideTabKey.Comment)}
                    className={styles.btn}
                />
            </div>
        </div>
    );
};

export default Entry;
